import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaSearch, FaUsers, FaChartLine, FaHandshake } from 'react-icons/fa';
import '../../../assets/css/Buyer/aboutus/about.css';

const AboutFeatures = ({
  title = "Your Trusted Real Estate Partner",
  features = [
    {
      icon: FaSearch,
      title: "Personalizes Search",
      description: "Personalized search tailored to your unique needs."
    },
    {
      icon: FaUsers,
      title: "Experienced Team",
      description: "Experienced team delivering trust, results, and guidance."
    },
    {
      icon: FaChartLine,
      title: "Track Record",
      description: "Proven track record of success and satisfaction."
    },
    {
      icon: FaHandshake,
      title: "Client-Centric",
      description: "Client-centric approach focused on your satisfaction."
    }
  ]
}) => {
  return (
    <section className="features-section bg-dark text-white section-padding">
      <Container>
        <div className="text-center mb-5">
          <h2 className="section-text fw-bold animate-on-scroll">{title}</h2>
        </div>

        <Row className="g-4">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Col md={3} key={index} className={`animate-on-scroll delay-${index + 1}`}>
                <Card className="feature-card bg-cream text-dark h-100 border-0 p-3">
                  <Card.Body>
                    <div className="icon-wrapper mb-3">
                      <IconComponent size={28} />
                    </div>
                    <h5 className="fw-bold mb-3 feature-card-title">{feature.title}</h5>
                    <p className="small text-muted feature-card-description">
                      {feature.description}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default AboutFeatures;